import { z } from 'zod';

/**
 * 꾸미기 모달 폼 스키마. 코어 `DecorateAvatarSchema`의 quiz 부분집합
 * (NFT/지갑 필드 제외 — quiz 컨텍스트엔 지갑이 없다).
 *
 * 선택된 partId 는 코어와 동일하게 음수 컨벤션을 따른다(렌더 시 abs 처리).
 */
export const AvatarDecorateSchema = z.object({
  avatar: z.object({
    skinId: z.number(),
    faceId: z.number(),
    hairId: z.number(),
    clothesId: z.number(),
    accessoryIds: z.record(z.string(), z.number()).default({}),
  }),
});

export type AvatarDecorateForm = z.infer<typeof AvatarDecorateSchema>;
export type AvatarDecorateValue = AvatarDecorateForm['avatar'];
